enum LocalStoragePrefix {
  Signature = "Signature",
  PublicKey = "PublicKey",
}

export default LocalStoragePrefix;
